<template>
  <a-modal
    v-model="show"
    :width="960"
    title="快递鸟企业寄件用户协议"
  >
    <div>

      欢迎使用快递鸟企业寄件服务（以下简称“快递鸟”）。在使用快递鸟服务之前请先仔细阅读本协议。<br>
      以任何方式使用快递鸟即表示您已阅读并同意本协议，且接受本协议之约束。您可以选择不使用快递鸟服务。若您继续使用，您的使用行为将被视为对本协议全部内容的认可，如果您不同意任何条款，请立即停止使用。<br>
      版权<br>
      快递鸟为深圳市快金数据技术服务有限公司（以下简称“快金数据”）旗下网站。快递鸟包含之所有内容：文本、图形、LOGO、创意及软件等之知识产权及其他权利归属快金数据及快递鸟的内容/信息提供者，受中国及国际版权法的保护。对快递鸟上所有内容之复制（包括收集、组合和重新组合），快递鸟享有排他权并受中国及国际版权法的保护。<br>
      商标<br>
      快递鸟的图形、图片、图表、声音、创意、LOGO和服务名称、标识均受相关法律保护，该商标、专有名称、标识等不能在任何非属快递鸟的产品或服务上进行容易在客户中引起混淆或引起歧义的使用，或以任何曲解或诋毁快递鸟之形式使用。
      <br>
      网站使用
      <br>
      快递鸟及其任何组成部分不得被再造、复制、抄袭、交易，或为任何未经快递鸟允许的商业目的所使用。如果快递鸟确定客户行为违法或有损其网站和企业的利益，则快递鸟和其关联企业将保留，包括但不限于拒绝提供服务、冻结会员专有账户、和/或取消订单的权利。 您应对使用快递鸟的结果自行承担风险。快递鸟不保证查询结果满足您的要求，不保证查询服务不中断，不保证查询结果的安全性、正确性、及时性、合法性，不保证由于您使用服务而获得的信息将是准确的或可靠的；因网络状况、通讯线路、第三方网站等任何原因而导致您不能正常使用快递鸟，快递鸟不承担任何法律责任。
      <br>
      注册管理
      <br>
      如您在快递鸟注册，您同意根据注册页面的要求提供关于您或贵公司的真实的资料并维持和及时更新，使其保持准确和完整。倘若您提供任何不真实、不准确、不完整的资料，快递鸟有权暂停或终止您的注册身份及资料，并拒绝使用。
      <br>
      用户提交信息
      <br>
      快递鸟的某些区域（如快递单号查询框、意见反馈区）可能允许您提交数据、信息、文本、照片、图片或其他材料。提交这些信息即表示，您授予快递鸟不可撤销的、永久、免费的全球性许可使用权利（并有权在多个层面对该权利进行再授权）。快递鸟可以用这些信息和材料进行使用和加工。
      <br>
      授予第三方网站的许可使用权
      <br>
      您使用快递鸟进行信息查询，如果信息请求结果需要链接至第三方网站才能获得，在此过程中快递鸟仅仅是为您提供信息获取的便利，您必须确保对此类第三方网站上所请求的信息和内容拥有所有必要权利（包括但不限于，对您或贵公司的快递单在快递公司官网获得跟踪轨迹信息、快递网点信息、快递员联系方式等所拥有的权利）并同意将此权利授予快递鸟。
      <br>
      链接
      <br>
      快递鸟的链接服务可以直接进入其他站点，这些链接的站点不受快递鸟的控制，快递鸟对任何与本站链接网站的内容不负责任。
      <br>
      版权投诉
      <br>
      快递鸟及其关联企业尊重他人之知识产权。如果您确认您的作品以某种方式被抄袭，该行为触犯了中国及国际版权法，请向快递鸟做版权投诉。
      <br>
      免责
      <br>
      快递鸟对快递鸟上所有内容包括但不限于网站运营或快递鸟上的信息、内容、材料或产品，不提供明示或暗示的担保。 从快递鸟获得的查询结果仅供您参考使用，如有差异请以快递公司官方查询结果为准，不作为投诉索赔依据。您了解并明确知悉快递鸟无法控制快递公司网站及资源，快递鸟对任何损失或任何由于使用或不能使用快递鸟而引起的损失，包括但不限于直接的，间接的，偶然的、惩罚性的和引发的损失，不承担责任。 任何通过快递鸟而链接到的第三方网页均系他人提供或制作，您可以从该第三方网页上获得查询结果、资讯及享用服务，快递鸟对其合法性、真实性、准确性概不负责，亦不承担任何法律责任。
      <br>
      操作规则
      <br>
      下面的条款和前面所述的条款均适用于快递鸟上的论坛，讨论组，聊天组，公告板和任何在网站上发生有相互影响作用区域的行为。网上用户使用、进入或参与上述区域或网站上的任何其他具相互影响作用区域，则表示同意所有这些条款。快递鸟不能也无法甄别所有网站用户提供的内容。但快递鸟保留对快递鸟上内容的监控权，并对快递鸟认为具有危害性，引起争议性的或违反本操作规则的其他内容进行删除的权利。为了提供满足快递鸟用户需求的高价值信息的服务，并避免快递鸟用户遭受因对他人权利的不实、恶意攻击或其他有害陈述而引起的损失，快递鸟有必要建立下列操作规则以避免快递鸟之被滥用： 当您使用快递鸟服务时，您不可以：
      <br>
      1） 粘贴或传播任何非法的，具威胁性的，诽谤性的，贬损的，报复的、亵渎的或任何其他法律禁止的信息，包括但不限于传播任何煽动性鼓励犯罪的，或违反公民义务或任何其他违反地方法规、国家法律、法规或国际法律、惯例或公约的内容；
      <br>
      2） 粘贴或传播任何散布任何他人的私人事件，粘贴或传播带有病毒，或任何带有贬损或损害性特征的内容；
      <br>
      3） 粘贴或传播任何可能侵害其他人财产权利的数据、图形或程序，包括以非法形式使用未经注册的版权文本、图形或程序，商业秘密及其他保密信息、商标、服务标识等；
      <br>
      4） 将快递鸟产生的信息用于除您本人之外的目的；
      <br>
      5） 以任何形式干扰快递鸟的其他用户。
      <br>
      隐私条例
      <br>
      本协议所指的“隐私”包括《电信和互联网用户个人信息保护规定》第4条规定的用户个人信息的内容以及未来不时制定或修订的法律法规中明确规定的隐私应包括的内容。
      <br>
      加强用户隐私保护是快递鸟的一项基本政策，并一直在严格贯彻执行，通过加强数据中心安全、增强应用程序安全、及时进行数据备份和恢复等一系列措施保障用户信息安全。快递鸟会竭尽全力保护用户信息，除非依据国家法律规定在有关国家机关查询时、被侵害的第三人提出权利主张或其他特殊情况下，快递鸟不会公开透露用户的注册资料及保存在本服务中的非公开内容。 用户完全理解并同意，快递鸟仅会通过透露统计数据，向合作伙伴、其他第三方以及为了其他合法目的而描述快递鸟的服务。
      <br>
      为提升服务的质量，快递鸟可能会与第三方合作共同向用户提供相关的互联网服务，此类合作可能需要包括但不限于快递鸟用户数据与第三方用户数据的互通。快递鸟承诺，除非事先得到您的许可，否则不会向任何无关第三方提供、分享您的个人信息。
      <br>
      用户体验改进计划
      <br>
      快递鸟不断努力以提升用户体验。为便于快递鸟为您提供更加稳定的服务，必要时快递鸟可能在您进行快递信息查询的时候通过您的查询终端（包括但不限于您所用的PC电脑，手机app等）进行一些信息查询可用性测试，以便于了解快递服务商的网络连接是否畅通，为此可能会产生少量临时查询数据，快递鸟承诺由此产生的数据不会涉及个人隐私。请您知晓并授权我们使用您的终端进行此类测试行为。
      <br>
      不可抗力
      <br>
      若因火灾、地震、台风、水灾、战争、或任何超出应负责任的我司实际上所能控制的状况等不可抗力事件的原因，致使不能履行接口服务时，我司不承担接口使用方的损失赔偿。
      <br>
      适用法律
      <br>
      快递鸟由快金数据运营和控制，适用中华人民共和国法律。我们保留随时更改快递鸟和上述免责及条款的权利。因本协议或本公司服务所引起或与其有关的任何争议应向快金数据所在地的法院提起诉讼。
      <br>
      深圳市快金数据技术服务有限公司
    </div>

    <div slot="footer">
      <a-button type="primary" @click="show = false">好的，我知道了</a-button>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    viz: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: this.viz
    }
  },
  watch: {
    show(n) {
      this.$emit('update:viz', n)
    },
    viz(n) {
      this.show = n
    }
  },
  methods: {
    close() {
      this.show = false
    },
    display() {
      this.show = true
    }
  }
}
</script>
<style lang="scss" scoped>
.c-tips{
    position: relative;
    .close{
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }
}
</style>
